var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 15.1451V24H2.95379e-07C-0.000354416 22.6044 0.318767 21.2273 0.932913 19.9742C1.54706 18.721 2.43993 17.6251 3.54311 16.7703C4.64628 15.9156 5.93049 15.3247 7.29732 15.043C8.66415 14.7613 10.0773 14.7963 11.4286 15.1451V15.1451ZM9.14286 13.7143C5.35429 13.7143 2.28571 10.6457 2.28571 6.85714C2.28571 3.06857 5.35429 0 9.14286 0C12.9314 0 16 3.06857 16 6.85714C16 10.6457 12.9314 13.7143 9.14286 13.7143ZM17.1429 17.8126L19.5669 15.3874L21.184 17.0046L18.7589 19.4286L21.184 21.8526L19.5669 23.4697L17.1429 21.0446L14.7189 23.4697L13.1017 21.8526L15.5269 19.4286L13.1017 17.0046L14.7189 15.3874L17.1429 17.8126Z",
    fill: "current-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserError);
export default __webpack_public_path__ + "static/media/user-error.ff4d8528.svg";
export { ForwardRef as ReactComponent };